import { Enum } from "@/utilities/enums/Enum.ts";

export const E_Webhook = Object.freeze({
  MAIN: "/url",
  GET_ONE: "url/one",
  CREATE_PRIVYR: "url/privyr",
  UPDATE_PRIVYR:(id: string) => `url/privyr/${id}`,
  DELETE_PRIVYR: (id: string) => `url/privyr/${id}`,
});

export type E_Webhook = Enum<typeof E_Webhook>;
